import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { User } from '@models/user.interface';
import { AuthService } from '@services/auth.service';
import { FontAwesomeService } from '@services/font-awesome.service';
import { ngxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-personal-info-card',
  templateUrl: './personal-info-card.component.html',
  styleUrls: ['./personal-info-card.component.scss'],
  host: {
    '(document:click)': 'onClose($event)',
  },
})
export class PersonalInfoCardComponent {
  public show = false;
  @Input() user: User;
  @ViewChild('popup') popup: ElementRef;

  constructor(
    private auth: AuthService,
    public translate: TranslateService,
    public faService: FontAwesomeService,
    private zendesk: ngxZendeskWebwidgetService
  ) {
  }

  // Change language at runtime
  public useLanguage(language: string) {
    this.translate.use(language);
    sessionStorage.setItem('lang', language);
    this.zendesk.setLocale(language);
  }

  public onClose(event): void {
    if (!this.popup.nativeElement.contains(event.target) && this.show) {
      this.toggleShow();
    }
  }

  public toggleShow(): void {
    this.show = !this.show;
  }

  getAppVersion() {
    return environment.version;
  }

  logout = () => this.auth.logout();

}



// WEBPACK FOOTER //
// ./src/app/components/personal-info-card/personal-info-card.component.ts